define.alias("shared/components/shared/post-tagging/select/tag-select-item", "settings/components/shared/post-tagging/select/tag-select-item");